import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class TicketResource extends AuthenticatedResource {
  static urlRoot = 'profile/:organization_slug/events/:event_slug/tickets';

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
